export const GET_TREATMENTS = 'GET_TREATMENTS';
export const SET_TREATMENTS = 'SET_TREATMENTS';
export const SET_NEW_TREATMENT = 'SET_NEW_TREATMENT';
export const CREATE_TREATMENT = 'CREATE_TREATMENT';
export const GET_TREATMENT_IMAGES = 'GET_TREATMENT_IMAGES';
export const SET_TREATMENT_IMAGES = 'SET_TREATMENT_IMAGES';
